import { Chip, Tooltip } from "@mui/material";
import { toShortSectionLabel } from "@/features/registryChangeAlert/utils/makeColumns";

/** 変動区分のバッジ。「甲区」「乙区」だけを小さく出し、「（所有権）」などの全文はツールチップで見せる。 */
export const SectionChip: React.FC<{ label: string }> = ({ label }) => (
  <Tooltip title={label} arrow enterTouchDelay={0}>
    <Chip
      label={toShortSectionLabel(label)}
      aria-label={label}
      size="small"
      color="warning"
      variant="outlined"
      sx={{ height: 20, fontSize: 11, "& .MuiChip-label": { px: 0.75 } }}
    />
  </Tooltip>
);
